import { useEffect, useState } from "react";
import {
  getBusinessList,
  getProjectList,
  getServiceList,
} from "../../../Pages/ecd-pages/EcdCRUD";
import NewHeaderData from "./NewHeaderData";
import { toast } from "react-toastify";

// Utility to slugify strings for URLs
const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-");

const useHeaderData = () => {
  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    fetchDropdowns();
  }, []);
  const fetchDropdowns = async () => {
    try {
      const [businessRes, servicesRes, projectsRes] = await Promise.all([
        getBusinessList(),
        getServiceList(),
        getProjectList(),
      ]);
      const businessItems =
        businessRes?.data?.responseObject?.map((b) => {
          if (b.businessID === 3) {
            return {
              title: b.businessName,
              link: "https://ecobuildweb.agmetech.com", // Static URL for BusinessID 1
              // link: "http://localhost:4012", // Static URL for BusinessID 1
              external: true, // Add a flag to know it should open in a new tab
            };
          } else {
            return {
              title: b.businessName,
              link: `/page/${slugify(b.businessName)}`, // Internal dynamic route
              external: false,
            };
          }
        }) || [];

      const serviceItems =
        servicesRes?.data?.responseObject
          ?.filter((s) => s.businessID === 1) // Filter by Business ID = 2
          ?.map((s) => ({
            title: s.serviceName,
            link: `/page/all-service/${s.serviceID}`,
          })) || [];

      // const projectItems =
      //   projectsRes?.data?.responseObject
      //     ?.filter((p) => p.businessID === 1)
      //     ?.map((p) => ({
      //       title: p.projectName,
      //       link: `/page/${slugify(p.projectName)}`,
      //     })) || [];

      const dropdownMap = {
        business: businessItems,
        services: serviceItems,
        // projects: projectItems,
      };

      const enrichedMenu = NewHeaderData.map((item) =>
        item.key && dropdownMap[item.key]
          ? { ...item, dropdown: dropdownMap[item.key] }
          : item
      );

      setMenuData(enrichedMenu);
    } catch (error) {
      toast.error("Failed to load dropdowns:", error);
    }
  };

  return menuData;
};

export default useHeaderData;
